export default __webpack_public_path__ + "static/media/REFIN_IMMAGINI-PRESTIGIO-DECORI_ARCADIA_craquele_265.86a039b6.jpg";